import { memo } from "react";
import { Document, Page, Text, View } from "@react-pdf/renderer";
import "../../components/pdf/Fonts.js";
import { milkProblemExplanation } from "../../utils/milk-calculation-messages.js";

const styles = {
    page: {
        paddingTop: 34,
        paddingBottom: 42,
        paddingHorizontal: 32,
        fontFamily: "Roboto",
        fontSize: 9,
        color: "#222222",
    },
    title: { fontSize: 15, fontWeight: 700, marginBottom: 8 },
    metadata: { fontSize: 9, marginBottom: 4 },
    sectionTitle: { fontSize: 11, fontWeight: 700, marginTop: 15, marginBottom: 6 },
    warning: { fontSize: 8, marginBottom: 4, color: "#9a3412" },
    tableHeader: {
        flexDirection: "row",
        backgroundColor: "#e7edf0",
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderColor: "#9ca3af",
        paddingVertical: 6,
    },
    row: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderColor: "#e5e7eb",
        paddingVertical: 6,
    },
    flockCode: { width: "12%", paddingHorizontal: 4 },
    registrationCode: { width: "18%", paddingHorizontal: 4 },
    problem: { width: "27%", paddingHorizontal: 4 },
    explanation: { width: "43%", paddingHorizontal: 4 },
    headerCell: { fontSize: 8, fontWeight: 700 },
    cell: { fontSize: 8 },
    footer: { position: "absolute", bottom: 18, left: 32, right: 32, textAlign: "center", fontSize: 8, color: "#6b7280" },
};

const MilkCalculationIssuesPdf = ({ ownerName, periodLabel, animalIssueRows, incompleteMilkRecordings }) => (
    <Document title="Προβλήματα υπολογισμού γαλακτοπαραγωγής">
        <Page size="A4" style={styles.page} wrap>
            <Text style={styles.title}>Προβλήματα υπολογισμού γαλακτοπαραγωγής</Text>
            <Text style={styles.metadata}>Εκτροφή: {ownerName || "—"}</Text>
            <Text style={styles.metadata}>Περίοδος: {periodLabel || "—"}</Text>

            {incompleteMilkRecordings.length > 0 && (
                <View>
                    <Text style={styles.sectionTitle}>Ελλιπείς καταχωρήσεις</Text>
                    {incompleteMilkRecordings.map((recording) => (
                        <Text key={String(recording.milkRecordingId)} style={styles.warning}>
                            {recording.warning} Ημερομηνία: {recording.testDate ? new Date(recording.testDate).toLocaleDateString("el-GR") : "—"}.
                        </Text>
                    ))}
                    <Text style={styles.warning}>Για τις παρακάτω περιόδους δεν υπολογίστηκε το γάλα. Συμπληρώστε τα στοιχεία που λείπουν και κάντε ξανά τον υπολογισμό.</Text>
                </View>
            )}

            <Text style={styles.sectionTitle}>Προβλήματα ανά ζώο ({animalIssueRows.length})</Text>
            <View style={styles.tableHeader} fixed>
                <Text style={[styles.flockCode, styles.headerCell]}>Κωδικός ζώου</Text>
                <Text style={[styles.registrationCode, styles.headerCell]}>Κωδικός μητρώου</Text>
                <Text style={[styles.problem, styles.headerCell]}>Πρόβλημα</Text>
                <Text style={[styles.explanation, styles.headerCell]}>Επεξήγηση</Text>
            </View>
            {animalIssueRows.length > 0 ? animalIssueRows.map((row) => (
                <View key={row.id} style={styles.row} wrap={false}>
                    <Text style={[styles.flockCode, styles.cell]}>{row.flockCode || "—"}</Text>
                    <Text style={[styles.registrationCode, styles.cell]}>{row.registrationCode || "—"}</Text>
                    <Text style={[styles.problem, styles.cell]}>{row.title}</Text>
                    <Text style={[styles.explanation, styles.cell]}>{milkProblemExplanation(row)}</Text>
                </View>
            )) : (
                <Text style={styles.cell}>Δεν βρέθηκαν προβλήματα στα ζώα.</Text>
            )}
            <Text
                style={styles.footer}
                fixed
                render={({ pageNumber, totalPages }) => `Σελίδα ${pageNumber} από ${totalPages}`}
            />
        </Page>
    </Document>
);

export default memo(MilkCalculationIssuesPdf);
